<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-6" >
                            <q-input v-model="model.SerialNumber" type="text" 
                                     label="Serial Number *" 
                                     autofocus 
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('SerialNumber')"
                                     :error-message="fieldErrorMessage('SerialNumber')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.SKU" type="text" 
                                     label="SKU *" 
                                      
                                      
                                      
                                     :rules="[val => val && val.length > 0 || 'Required',]"
                                     :error="fieldHasError('SKU')"
                                     :error-message="fieldErrorMessage('SKU')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-6" >
                            <q-select v-model="model.PartnerCode" 
                                      label="Partner Code *" 
                                       
                                       
                                      :options="dataSourceLookupThreePLPartnerCodes" option-value="Key" option-label="Value"
                                      emit-value map-options 
                                       
                                      :rules="[val => !!val || 'Required',]"
                                      :error="fieldHasError('PartnerCode')"
                                      :error-message="fieldErrorMessage('PartnerCode')"
                                      
                                      @input="onPartnerCodeChange(model, ...arguments)"
                                      
                                      dense options-dense>
                                
                                
                                
                            </q-select>
                        </div>
<div class="col-6" >
                            <q-input v-model="model.ClientId" type="text" 
                                     label="Client Id" 
                                      
                                      
                                      
                                     :rules="[]"
                                     :error="fieldHasError('ClientId')"
                                     :error-message="fieldErrorMessage('ClientId')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './threeplserialnumberaddeditmodel-dialog-screen.js'
</script>